export default "__VITE_ASSET__CeFDFA8F__"